import React from "react";
import styles from "./StartNowBtn.module.css";

const StartNowBtn = ({
    mainText = "START NOW",
    subText = "Setup in just 3 minutes",
    underline = "",    
    bold = "",          
    shapeType = "default",
    textColor = "#fff",
    fontFamily = "",
}) => {

    const shape = shapeType === "alt"
        ? "/Svg/shape-btn3.svg"
        : "/Svg/shape-btn.svg";

    // Process subText
    let finalSub = subText;

    // underline
    if (underline) {
        finalSub = finalSub.replace(
            underline,
            `<u>${underline}</u>`
        );
    }

    // bold
    if (bold) {
        finalSub = finalSub.replace(
            bold,
            `<strong>${bold}</strong>`
        );
    }

    return (
        <div className={styles.btn}>
            <img src={shape} alt="btn-shape" className={styles.shape} />

            <div className={styles.textWrapper}>
                <p
                    className={styles.mainText}
                    style={{ color: textColor, fontFamily }}
                >
                    {mainText}
                </p>

                <span
                    className={styles.subText}
                    dangerouslySetInnerHTML={{ __html: finalSub }}
                />
            </div>
        </div>
    );
};

export default StartNowBtn;
